module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {}, [(_vm.boxes) ? _c('div', {
    staticClass: "articles-wrapper col-xs-12",
    class: [_vm.boxes.length > _vm.boxlimit ? '' : 'no-more']
  }, _vm._l((_vm.boxes), function(box, index) {
    return (index < _vm.boxlimit) ? _c('div', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport"
      }],
      staticClass: "article-thumb col-sm-12 col-xs-12 no-gutters",
      class: [_vm.isHome ? 'col-md-6 isHome' : 'col-lg-12'],
      on: {
        "click": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "before", undefined, $event.key, undefined)) { return null; }
          return _vm.gotoCase(box)
        }
      }
    }, [_c('div', {
      staticClass: "mask-image col-md-6 col-sm-6 col-xs-12 no-gutters"
    }, [_c('div', {
      style: ({
        'background-image': 'url(' + box.elements.thumbnail_image.value[0].url + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-info col-md-6 col-sm-6 col-xs-12 no-gutters text-center"
    }, [(_vm.showCategory) ? _c('div', {
      staticClass: "box-type-name"
    }, [_vm._v(_vm._s(box.elements.word_category.value[0].name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(box.elements.header_title.value))]), _vm._v(" "), _c('div', [_c('ul', {
      staticClass: "competency-list"
    }, _vm._l((box.elements.approach.value), function(approach) {
      return _c('li', [_c('span', [_vm._v(_vm._s(_vm.modularContent[approach].system.name))])])
    }), 0)])])]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/words') ? [(_vm.boxes == 0) ? _c('div', {
    staticClass: "container-fluid no-results"
  }, [_c('p', [_vm._v("0 results for \"" + _vm._s(_vm.search) + "\"")]), _vm._v(" "), _vm._m(0)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.boxes.length > _vm.boxlimit) ? [(_vm.$route.path == _vm.pathRoute) ? _c('div', {
    staticClass: "load-more-container text-center col-xs-12"
  }, [_c('button', {
    staticClass: "btn_orange",
    on: {
      "click": function($event) {
        _vm.boxlimit += 8
      }
    }
  }, [_vm._v("LOAD MORE")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showViewAll) ? _c('div', {
    staticClass: "load-more-container text-center col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn_orange",
    attrs: {
      "to": _vm.pathRoute,
      "tag": "button"
    }
  }, [_vm._v("VIEW ALL")])], 1) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Check the spelling of your keywords.")]), _vm._v(" "), _c('li', [_vm._v("Try using fewer, different or more general keywords.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608c55a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/articles-solutions.vue
// module id = 1529
// module chunks = 0